<template>
  <va-show-layout>
    <va-show :item="item">
      <v-row justify="center">
        <v-col lg="8">
          <base-material-tabs-card
            :tabs="[
              { id: 'attributes', icon: 'mdi-eye' },
              { id: 'summary', icon: 'mdi-text' },
            ]"
          >
            <template #attributes>
              <v-row>
                <v-col>
                  <va-field source="isbn"></va-field>
                  <va-field source="cover" type="image" src="thumbnails.large"></va-field>
                  <va-field source="publisher" chip color="orange"></va-field>
                  <va-field source="title"></va-field>
                  <va-field source="category.name" type="chip"></va-field>
                </v-col>
                <v-col>
                  <va-field source="formats" type="array" select></va-field>
                  <va-field source="tags" type="array"></va-field>
                  <va-field source="updated" type="date"></va-field>
                  <va-field source="authors" color="orange"></va-field>
                </v-col>
              </v-row>
              <va-field source="short_description"></va-field>
            </template>
            <template #summary>
              <va-rich-text-field source="short_description"></va-rich-text-field>
            </template>
          </base-material-tabs-card>
        </v-col>
      </v-row>
    </va-show>
    <base-material-card
      :icon="$admin.getResource('exercises').icon"
      :title="$admin.getResource('exercises').pluralName"
    >
      <template v-if="item !== null">
        <va-list
          resource="exercises"
          disable-pagination
          disable-query-string
          :filter="{
            resourceId: item.uid,
          }"
        >
          <va-data-table :fields="fields" disable-select></va-data-table>
        </va-list>
      </template>
    </base-material-card>
  </va-show-layout>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    item: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      fields: [
        { source: 'title', sortable: true },
        { source: 'lastUpdatedAt', sortable: true },
        { source: 'publisher', sortable: true },
        { source: 'main_language', sortable: true },
        {
          source: 'updated',
          type: 'date',
          sortable: true,
        },
      ],
    };
  },
};
</script>
